import { render, staticRenderFns } from "./demographicsPersonas.vue?vue&type=template&id=72014dbe&lang=pug"
import script from "./demographicsPersonas.vue?vue&type=script&lang=js"
export * from "./demographicsPersonas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports